function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCloudCheckIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "28px",
  height: "28px",
  viewBox: "0 0 24 24",
  id: "cloud-check",
  xmlns: "http://www.w3.org/2000/svg",
  className: "icon multi-color"
}, props), /*#__PURE__*/React.createElement("title", {
  style: {
    strokeWidth: 2
  }
}, "Action Confirmation"), /*#__PURE__*/React.createElement("path", {
  id: "tertiary-fill",
  d: "M15.66,8.05A3.67,3.67,0,0,0,15,8a5,5,0,0,0-5,4.8A3,3,0,0,0,5.76,17,3,3,0,1,1,8,11.8,5,5,0,0,1,13,7a4.94,4.94,0,0,1,2,.42Z",
  style: {
    fill: "#b7b7b7",
    strokeWidth: 2
  }
}), /*#__PURE__*/React.createElement("path", {
  id: "primary-stroke",
  d: "M20.83,13A3,3,0,0,1,18,17H6a3,3,0,1,1,2-5.2A5,5,0,0,1,13,7a4.94,4.94,0,0,1,2,.42",
  style: {
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }
}), /*#__PURE__*/React.createElement("polyline", {
  id: "secondary-stroke",
  points: "13 11 15 13 20 8",
  style: {
    fill: "none",
    stroke: "rgb(44, 169, 188)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }
}));
export { SvgCloudCheckIcon as ReactComponent };
export default __webpack_public_path__ + "assets/96547357.svg";